import { Link } from "react-router-dom"

export default function TermsPage() {
  const currentYear = new Date().getFullYear()

  return (
    <article
      style={{
        maxWidth: 760,
        width: "100%",
        margin: "0 auto",
        padding: "clamp(24px, 6vw, 48px) clamp(20px, 4vw, 32px)",
        display: "grid",
        gap: "clamp(20px, 3vw, 28px)",
      }}
    >
      <header>
        <h1
          className="mono"
          style={{
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            fontSize: "clamp(1.4rem, 4vw, 1.8rem)",
            marginBottom: "12px",
          }}
        >
          Terms of Service
        </h1>
        <p className="small" style={{ color: "var(--muted)" }}>
          Last Updated: January {currentYear}
        </p>
      </header>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Agreement to Terms
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          By accessing or using Sales Demon (&ldquo;Service&rdquo;), you agree to be bound by these Terms of
          Service. If you do not agree to these terms, do not use the Service.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Description of Service
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Sales Demon is an AI-powered invoicing and payment notification assistant that operates
          through SMS text messages. The Service allows you to create invoices, receive payment
          notifications, and manage customer communications via your dedicated phone number.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          User Responsibilities
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7, marginBottom: "12px" }}>
          By using the Service, you agree to:
        </p>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px" }}>
          <li>Use the platform responsibly and in compliance with all applicable laws</li>
          <li>Maintain compliance with all messaging regulations (including TCPA, CTIA guidelines)</li>
          <li>Avoid transmitting sensitive payment data (card numbers, CVV) through chat</li>
          <li>Provide accurate information during registration</li>
          <li>Maintain the security of your account credentials</li>
          <li>Obtain proper consent before sending messages to your customers</li>
        </ul>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          SMS Communications
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7, marginBottom: "12px" }}>
          By registering for Sales Demon and verifying your phone number, you consent to receive
          SMS messages related to your account, invoices, payments, and service operations.
        </p>
        <p style={{ color: "var(--muted)", lineHeight: 1.7 }}>
          For complete details on SMS messaging, including opt-out instructions, message
          frequency, and data handling, please review our{" "}
          <Link to="/legal/sms-terms" style={{ color: "var(--accent-text)" }}>
            SMS Terms of Service
          </Link>{" "}
          and{" "}
          <Link to="/legal/sms-compliance" style={{ color: "var(--accent-text)" }}>
            SMS Compliance documentation
          </Link>
          .
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Payment Processing
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Sales Demon integrates with Stripe for payment processing. By connecting your Stripe
          account, you agree to Stripe&apos;s terms of service. We do not store credit card numbers
          or sensitive payment credentials on our servers.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Prohibited Uses
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7, marginBottom: "12px" }}>
          You may not use the Service to:
        </p>
        <ul style={{ color: "var(--muted)", lineHeight: 1.8, paddingLeft: "20px" }}>
          <li>Send spam, unsolicited messages, or marketing without consent</li>
          <li>Engage in fraudulent or deceptive practices</li>
          <li>Violate any applicable laws or regulations</li>
          <li>Transmit malicious content or attempt to compromise the Service</li>
          <li>Impersonate others or misrepresent your identity</li>
        </ul>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Limitation of Liability
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Sales Demon is provided &ldquo;as is&rdquo; without warranties of any kind. We are not liable for
          any indirect, incidental, or consequential damages arising from your use of the
          Service, including lost profits or business interruption.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Changes to Terms
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Demons and Fairies Inc. may update these terms with notice. Continued usage after
          updates constitutes acceptance of the revised terms. We will notify you of significant
          changes via email or through the Service.
        </p>
      </section>

      <section>
        <h2
          className="mono"
          style={{
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontSize: "1rem",
            marginBottom: "12px",
            color: "var(--accent-text)",
          }}
        >
          Contact
        </h2>
        <p style={{ color: "var(--text)", lineHeight: 1.7 }}>
          Questions about these terms? Contact us at{" "}
          <a href="mailto:support@salesdemon.ai" style={{ color: "var(--accent-text)" }}>
            support@salesdemon.ai
          </a>
        </p>
      </section>

      <footer
        style={{
          marginTop: "16px",
          paddingTop: "20px",
          borderTop: "1px solid var(--rail)",
          display: "flex",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <Link
          to="/legal/sms-terms"
          className="mono small"
          style={{ color: "var(--accent-text)", letterSpacing: "0.08em" }}
        >
          SMS Terms →
        </Link>
        <Link
          to="/legal/sms-compliance"
          className="mono small"
          style={{ color: "var(--accent-text)", letterSpacing: "0.08em" }}
        >
          SMS Message Flow →
        </Link>
        <Link
          to="/legal/privacy"
          className="mono small"
          style={{ color: "var(--accent-text)", letterSpacing: "0.08em" }}
        >
          Privacy Policy →
        </Link>
        <Link
          to="/"
          className="mono small"
          style={{ color: "var(--muted)", letterSpacing: "0.08em" }}
        >
          ← Back to Home
        </Link>
      </footer>
    </article>
  )
}
